import { capitalizeFirstLetter } from "helpers/capitalizeFirstLetter";
import React from "react";

interface ButtonProps
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  priority?: "primary" | "secondary" | "tertiary" | "red";
  size?: "regular" | "small";
  icon?: string;
  isPublic?: boolean;
}

export const Button: React.FC<ButtonProps> = ({
  priority,
  size,
  icon,
  className,
  children,
  isPublic = false,
  ...props
}) => {
  const classNameProp = className ? className : "";
  const priorityClass = priority ? `Btn${capitalizeFirstLetter(priority)}` : "";
  const sizeClass = size ? `Btn${capitalizeFirstLetter(size)}` : "";

  return (
    <button
      {...props}
      className={`Btn CustomBtn ${classNameProp} ${priorityClass} ${sizeClass} ${
        isPublic ? "PublicBtn" : ""
      }`}
    >
      {icon && <img src={icon} alt="Button icon" className="ButtonIcon" />}
      {children}
    </button>
  );
};
